import { render, staticRenderFns } from "./VendorsTable.vue?vue&type=template&id=6be94d56&scoped=true&lang=pug&"
import script from "./VendorsTable.vue?vue&type=script&lang=js&"
export * from "./VendorsTable.vue?vue&type=script&lang=js&"
import style0 from "./VendorsTable.vue?vue&type=style&index=0&id=6be94d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be94d56",
  null
  
)

export default component.exports